import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-bullets',
  templateUrl: './bullets.component.html',
  styleUrls: ['./bullets.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BulletsComponent implements OnInit {
  @Input() label: string;
  @Input() message?;
  public isActive = false;
  constructor() {}

  ngOnInit(): void {}

  public showTooltip() {
    setTimeout(() => {
      this.isActive = true;
    }, 300);
  }

  public hideTooltip() {
    setTimeout(() => {
      this.isActive = false;
    }, 500);
  }

  get labelWithBold() {
    return this.label.replace('Sustento', '<strong>Sustento</strong>');
  }
}
